import { cleanEnv, str, bool } from 'envalid';

export enum Environment {
  Development = 'development',
  Production = 'production',
}

interface ProcessEnvVariables {
  npm_package_version: string;
  VITE_API_URL: string;
  VITE_INSTANCE_NAME: Environment;
  VITE_DEBUG_ENABLED: boolean;
  VITE_AUTH_GOOGLE_CLIENT_ID: string;
}

// object needs to be defined to properly inject env variables in production build
const processEnvs: Record<keyof ProcessEnvVariables, string | undefined> = {
  VITE_API_URL: process.env.VITE_API_URL,
  VITE_INSTANCE_NAME: process.env.VITE_INSTANCE_NAME,
  VITE_DEBUG_ENABLED: process.env.VITE_DEBUG_ENABLED,
  VITE_AUTH_GOOGLE_CLIENT_ID: process.env.VITE_AUTH_GOOGLE_CLIENT_ID,
  npm_package_version: process.env.npm_package_version,
};

const envs = cleanEnv<ProcessEnvVariables>(processEnvs, {
  VITE_API_URL: str({ default: '' }),
  VITE_INSTANCE_NAME: str({ choices: Object.values(Environment) }),
  VITE_DEBUG_ENABLED: bool({ default: false }),
  VITE_AUTH_GOOGLE_CLIENT_ID: str(),
  npm_package_version: str(),
});

export interface Config {
  apiUrl: URL;
  auth: {
    googleClientId: string;
  };
  instanceName: Environment;
  isDebug: boolean;
  isDev: boolean;
  version: string;
}

export const config: Config = {
  apiUrl: new URL(envs.VITE_API_URL || window.location.origin),
  auth: {
    googleClientId: envs.VITE_AUTH_GOOGLE_CLIENT_ID,
  },
  instanceName: envs.VITE_INSTANCE_NAME,
  isDebug: envs.VITE_INSTANCE_NAME === Environment.Development && envs.VITE_DEBUG_ENABLED,
  isDev: envs.VITE_INSTANCE_NAME === Environment.Development,
  version: envs.npm_package_version,
};
